module.exports = __webpack_public_path__ + "svg_80x80/xamarin.390652.svg";